<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane
        v-for="item in blockId == '06' ? tabListSingle : tabList"
        :label="item.label"
        :name="item.name"
        :key="item.label"
      ></el-tab-pane>
    </el-tabs>
    <el-row class="contentWrapper">
      <el-col :xs="24" :sm="14" class="leftCard">
        <AppDrag
          v-for="item in blockId == '06' ? tabListSingle : tabList"
          :key="item.name"
          v-show="activeName == item.name"
          :sourceType="item.name"
          :selectList="selectList"
          :styleCode="styleCode"
          :moduleCode="moduleCode"
          :isShowDesttop="true"
          :tabulatioName="tabulatioName"
          :blockId="blockId"
        ></AppDrag>
      </el-col>
      <el-col :xs="24" :sm="10" class="rightCard">
        <div>
          提交信息：
          <span v-if="deployNum && (styleCode == 201 || styleCode == 202)">
            部署数量：<span style="font-weight: bold">{{ deployNum }}</span>
          </span>
        </div>

        <div class="summitContent borderA">
          <AppReceiverFixCount
            v-if="styleCode == 201"
            :selectList="selectList"
            :styleCode="styleCode"
            class="selectList"
          ></AppReceiverFixCount>
          <AppReceiver202
            v-else-if="styleCode == 202"
            v-model="selectList"
            :styleCode="styleCode"
            class="selectList"
          >
          </AppReceiver202>
          <AppReceiver
            v-else
            :styleCode="styleCode"
            v-model="selectList"
            class="selectList"
            :blockId="blockId"
            :showHighPriority="showHighPriority"
          ></AppReceiver>
        </div>
        <div class="optionArea">
          <div class="left-btns">
            <el-button
              v-if="showHighPriority"
              type="primary"
              @click="handlePreview"
              >下发预览</el-button
            >
          </div>
          <div class="right-btns">
            <el-button type="primary" @click="handleSubmit">保存</el-button>
            <el-button type="danger" @click="handleClear">清空</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 下发预览抽屉 -->
    <el-drawer
      title="下发预览"
      :visible.sync="previewDrawerVisible"
      direction="rtl"
      size="550px"
      :append-to-body="true"
    >
      <div class="preview-drawer-container">
        <div class="preview-drawer-content">
          <div
            v-for="(item, index) in previewList"
            :key="index"
            class="preview-item"
          >
            {{ index + 1 }}. {{ item.apkName }} ({{ item.packageName }})
          </div>
        </div>
        <div class="drawer-footer">
          <el-button type="primary" @click="previewDrawerVisible = false"
            >确认</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import AppDrag from "@/components/deploy2/AppDrag";
import AppReceiver from "@/components/deploy2/AppReceiver";
import AppReceiverFixCount from "@/components/deploy2/AppReceiverFixCount";
import AppReceiver202 from "@/components/deploy2/AppReceiver202";
import { sourceTypeList1 } from "@/common/constant/constant";
import {
  getPageConfigDetail,
  savePageConfig,
  deployPreview,
} from "@/api/ozBlockConf";

export default {
  name: "keywordsAd",
  components: { AppDrag, AppReceiver, AppReceiverFixCount, AppReceiver202 },
  props: [
    "blockConfId",
    "blockId",
    "styleCode",
    "deployNum",
    "moduleCode",
    "tabulatioName",
  ],
  data() {
    return {
      activeName: "app",
      selectList: [],
      previewDrawerVisible: false,
      previewList: [],
      tabList: [
        {
          id: 0,
          label: "自营应用",
          name: "app",
          tag: "success",
        },
        {
          id: 2,
          label: "Aptoide应用",
          name: "aptoi",
          tag: "warning",
        },
        {
          id: 6,
          label: "GP推广资源",
          name: "gp_prompt",
          tag: "primary",
        },
      ],
      tabListSingle: [
        {
          id: 0,
          label: "自营应用",
          name: "app",
          tag: "success",
        },
        // {
        //   id: 5,
        //   label: "运营商应用",
        //   name: "operator",
        //   tag: "primary",
        // },
      ],
    };
  },
  computed: {
    // 是否显示高优先级勾选框：正方形运营位ICON(03)、常用应用No.2(05)、常用应用No.4(04)
    showHighPriority() {
      // 使用宽松比较，兼容字符串和数字类型
      const blockId = String(this.blockId);
      const result = blockId === "03" || blockId === "05" || blockId === "04";
      console.log(
        "[showHighPriority] blockId:",
        this.blockId,
        "converted:",
        blockId,
        "result:",
        result
      );
      return result;
    },
  },
  created() {
    this.getKeywordAdDetail(this.blockConfId);
  },
  methods: {
    handleSubmit() {
      this.keywordAdAdd();
    },
    // 下发预览
    async handlePreview() {
      // 根据当前部署列表生成预览数据
      const validList = this.selectList.filter(
        (item) => item.apkId || item.resType === 30008
      );
      if (validList.length === 0) {
        this.$message.warning("请先部署应用");
        return;
      }
      // 构造请求参数，只传递必要字段
      const list = validList.map((item) => ({
        id: item.id || undefined,
        blockConfId: this.blockConfId,
        resType: item.resType,
        resName: item.resName,
        brief: item.brief,
        apkId: item.apkId,
        packageName: item.packageName,
        showInstallBtn: item.showInstallBtn,
        webUrl: item.webUrl,
        imgUrl: item.imgUrl,
        video_url: item.video_url,
        site: item.site,
        promotionId: item.promotionId,
        status: item.status,
        isChecked: item.isChecked ? 1 : 2,
        forceChecked: item.forceChecked ? 1 : 0,
        isHighPriority: item.isHighPriority ? 1 : 0,
      }));
      const params = {
        blockConfId: this.blockConfId,
        blockId: this.blockId,
        list,
      };
      try {
        const res = await deployPreview(params);
        if (res && res.code === 0) {
          this.previewList = (res.data || []).map((item) => ({
            apkName: item.apkName || item.app?.apkName || item.resName,
            packageName: item.packageName || item.app?.packageName || "",
          }));
          this.previewDrawerVisible = true;
        } else {
          this.$message.error(res?.msg || "预览失败");
        }
      } catch (error) {
        this.$message.error("预览请求失败");
      }
    },
    handleClear() {
      if (this.styleCode == 202 || this.styleCode == 201) {
        const num = this.styleCode == 201 ? 3 : 2;
        let arr = [];
        for (let i = 0; i < num; i++) {
          arr.push({
            imgUrl: "",
            webUrl: "",
            radio: 1,
            isChecked: false,
            forceChecked: false,
            dragList: [],
          });
        }
        this.selectList = arr;
      } else {
        this.selectList = [];
      }
    },
    async getKeywordAdDetail(id) {
      let res = await getPageConfigDetail({
        blockConfId: id,
        moduleType: 2,
      });
      const list = res.data || [];

      this.selectList = list.map((item) => {
        item.apkName = item.apkName || item.app?.apkName;
        const sourceType = sourceTypeList1.find((tl) => tl.id == item.resType);
        if (sourceType) {
          item.sourceType = sourceType.name;
        } else {
          if (item.resType == 30008) {
            item.sourceType = "gp_prompt";
          } else {
            item.sourceType = "promotion";
          }
        }
        if (item.resType == 30008) {
          item = { ...item, ...item.gpApp };
          item.apkName = item.appName;
          delete item.gpApp;
          item.radio = 1;
        } else {
          item.radio = item.webUrl ? 2 : 1;
        }
        item.isChecked = item.isChecked == 1;
        item.forceChecked = item.forceChecked == 1; // 1表示true，0表示false
        item.isHighPriority = item.isHighPriority == 1; // 1表示true，0表示false

        item.dragList = [];
        if (
          this.styleCode == 201 ||
          (this.styleCode == 202 &&
            ((item.app && item.app.apkId) || item.resType == 30008))
        ) {
          item.dragList = [item];
        }
        return item;
      });
      let selectListNum = this.selectList.length;
      let deployNum;
      if (
        (this.styleCode == 201 || this.styleCode == 202) &&
        selectListNum < this.deployNum
      ) {
        deployNum = this.deployNum - selectListNum;
        for (let j = 0; j < deployNum; j++) {
          this.selectList.push({
            imgUrl: "",
            webUrl: "",
            radio: 1,
            isChecked: false,
            forceChecked: false,
            dragList: [],
          });
        }
      } else if (
        (this.styleCode == 201 || this.styleCode == 202) &&
        selectListNum > this.deployNum
      ) {
        this.selectList = this.selectList.slice(0, this.deployNum);
      }
    },
    checkArray(list) {
      const regex = /^(https?:\/\/)[^\s$.?#].[^\s]*$/i;
      for (const item of list) {
        if (item.radio === 2) {
          if (!regex.test(item.webUrl)) {
            return false;
          }
        }
      }
      return true;
    },
    async keywordAdAdd() {
      const list = this.selectList.map((item, index) => {
        item.blockConfId = this.blockConfId;
        item.site = index + 1;

        if (item.resType !== 30008) {
          if (item.radio == 1) {
            item.webUrl = "";
          }
          if (item.radio == 2) {
            item.resType = 2001; //2001 外部链接
          }
        }
        return item;
      });
      const data = {
        blockConfId: this.blockConfId,
        moduleType: 2,
        list,
      };
      // 图片合集校验
      if (this.styleCode == 201 || this.styleCode == 202) {
        const isValid = list.some((item, index) => {
          if (index == 0) {
            if (
              !item.imgUrl ||
              (item.radio == 2 && !item.webUrl) ||
              (item.radio == 1 &&
                (item.dragList.length <= 0 ||
                  (!item.dragList[0].apkId && !item.dragList[0].resType)))
            ) {
              return true;
            }
          }
        });
        if (isValid) {
          this.$message.error("请检查数据是否填写完整");
          return;
        }
        if (!this.checkArray(list)) {
          this.$message.error("请输入正确链接");
          return;
        }
        // // 网络链接校验
        // const isNetwork = list.some(function (item) {
        //   if (item.radio == 2 && IsURL(item.webUrl)) {
        //     return true;
        //   }
        // });
        // if (!isNetwork) {
        //   this.$message.error("请输入正确链接");
        //   return;
        // }
      }
      data.list.forEach((element, index) => {
        element.isChecked = element.isChecked ? 1 : 2;
        element.forceChecked = element.forceChecked ? 1 : 0; // true转为1，false转为0
        element.isHighPriority = element.isHighPriority ? 1 : 0; // true转为1，false转为0

        if (element.dragList && element.dragList.length > 0) {
          const dragItem = element.dragList[0];
          // 移除可能的循环引用
          delete element.dragList; // 避免循环引用

          element = {
            ...element, // 展开原始对象的属性
            ...dragItem, // 合并dragList中第一个元素的属性
          };
        }
      });
      const res = await savePageConfig(data);
      if (res) {
        this.$message.success("部署成功");
        this.$emit("closeBtn");
      }
    },
  },
};
</script>

<style lang="scss">
.contentWrapper {
  height: 400px;

  .leftCard,
  .rightCard {
    height: 100%;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
  }

  .rightCard {
    display: flex;
    flex-direction: column;
    padding: 10px;

    .summitContent {
      flex: 1;
      margin: 10px 0;
      overflow: auto;

      .selectList {
        height: 100%;
      }
    }

    .optionArea {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .itemArea {
      width: 95%;
    }
  }
}

.preview-drawer-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .preview-drawer-content {
    max-height: 800px;
    padding: 20px;
    overflow-y: auto;

    .preview-item {
      padding: 8px 0;
      border-bottom: 1px solid #eee;
      font-size: 14px;
      word-break: break-all;
      line-height: 1.5;

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .drawer-footer {
    padding: 10px 20px;
    text-align: right;
    border-top: 1px solid #eee;
    flex-shrink: 0;
  }
}
</style>
